import { render, staticRenderFns } from "./SecRole.vue?vue&type=template&id=f44bdb3a&"
import script from "./SecRole.vue?vue&type=script&lang=js&"
export * from "./SecRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports